<template>
    <router-view></router-view>
</template>

<script>

  export default {
    name: 'turkish',
    props: {},
    data () {
      return {}
    },
    methods: {
    },
    computed: {
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// turkish.vue?4f1997c6